import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/shared/lib/cn";

interface PageHeaderProps extends ComponentProps<"header"> {
  title: string;
  eyebrow?: string;
  description?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({
  title,
  eyebrow,
  description,
  actions,
  className,
  ...props
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        "flex min-w-0 flex-wrap items-start justify-between gap-2 border-b border-border pb-2",
        className,
      )}
      {...props}
    >
      <div className="min-w-32 flex-1">
        {eyebrow ? (
          <div className="truncate font-mono text-[0.68rem] font-bold tracking-[0.13em] text-primary uppercase">
            {eyebrow}
          </div>
        ) : null}
        <h1 className="m-0 font-mono text-lg font-bold tracking-[0.06em] uppercase sm:text-xl">
          {title}
        </h1>
        {description ? (
          <p className="mt-0.5 mb-0 text-sm text-foreground-muted">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="ml-auto flex shrink-0 items-center gap-1.5">
          {actions}
        </div>
      ) : null}
    </header>
  );
}
